import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import { MdCall } from "react-icons/md";
import { GrMail } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import { BsFillSuitHeartFill } from "react-icons/bs";
import instaLogo from "../../assets/img/instagram.png";
import whatsapp from '../../assets/img/WhatsApp_icon.png';
import facebook from '../../assets/img/facebook.png';
import youtube from '../../assets/img/youtube.png';
import Logo from '../../assets/img/Threads.png';
import Fssai from '../../assets/img/fssai-removebg-preview.png';
import Msme from '../../assets/img/msme-removebg-preview.png';

const Footer = () => {
  const [pathMap, setPathMap] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/navbar.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data && res.data.path_map) {
          setPathMap(res.data.path_map);
        }
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      <footer style={{backgroundColor:"var(--footer)"}} id="tempaltemo_footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 pt-5">
              <h2 className="h2 text-success border-bottom pb-3 border-light logo">
                Sivam Farms
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <HiLocationMarker className="me-2 mb-1 text-white" />
                  NO-179/A PERIYA THERU,
                  <br />
                  PERIYA ILLAVANTHANGAL,
                  <br />
                  REDDYKUPPAM,
                  <br />
                  VANDAVASI-604 502.
                </li>
                <li>
                  <MdCall className="me-2 mb-1" />
                  <a className="text-decoration-none text-white" href="tel:9840283274">
                    9840283274
                  </a>
                </li>
                <li>
                  <GrMail className="me-2 mb-1" />
                  <a
                    className="text-decoration-none text-white"
                    href="mailto:farmsivam@gmail.com"
                  >
                    farmsivam@gmail.com
                  </a>
                </li>
                
                  
                 
                
                <li>
                <a
                    className="text-decoration-none text-white"
                    href="https://instagram.com/sivamfarms.organics?igshid=MzRlODBiNWFlZA=="
                    target="blank"
                  >
                   <img
                    src={instaLogo}
                    height="30px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms instagram"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  
                  <a
                    className="text-decoration-none"
                    href="https://wa.me/c/919840283274"
                    target="blank"
                  >
                   <img
                    src={whatsapp}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms whatsapp"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                 
                  <a
                    className="text-decoration-none"
                    href="https://www.facebook.com/share/18VUVYM3aJ/"
                    target="blank"
                  >
                    <img
                    src={facebook}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms facebook"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a
                    className="text-decoration-none"
                    href="https://youtube.com/@sivamfarms524?si=UAQlGd1_ljnzApN1"
                    target="blank"
                  >
                   <img
                    src={youtube}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a
                    className="text-decoration-none"
                    href="https://www.threads.net/@sivamfarms.organics"
                    target="blank"
                  >
                   <img
                    src={Logo}
                    height="30px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  </a>
                </li>
               
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Products
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.herbal || "/herbalProduct"}>
                    Herbal Products
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.wellness || "/yoga"}>
                    Health And Wellness
                  </Link>
                </li>
                {/* <li>
                  <Link className="text-decoration-none text-white" to="/gardenProduct">
                    Garden Products
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/foodProduct">
                    Food Products
                  </Link>
                </li> */}
                {/* <li>
                <img
                    src={Fssai}
                    height="40px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  
                </li> */}
                <li>
                <img
                    src={Msme}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                </li>
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Further Info
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.home || "/"}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.about || "/about"}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.policy || "/policy"}>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to={pathMap.terms || "/terms"}>
                    Terms and Conditions
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="w-100 bg-black py-3">
          <div className="container">
            <div className="row pt-2">
              <div className="d-flex justify-content-between col-12">
                <p className="text-left text-light">
                  Copyright &copy; 2025 Sivam Farms
                </p>
                <a
                  href="https://vebbox.com/"
                  className="text-decoration-none text-light"
                >
                  Developed by vebbox software solutions with passion
                  <BsFillSuitHeartFill
                    className="ms-1"
                    style={{ color: "#c0392b", marginTop: "-5px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
